import { render } from "./AttributionFooter.vue?vue&type=template&id=e5c3b896&scoped=true"
import script from "./AttributionFooter.vue?vue&type=script&lang=js"
export * from "./AttributionFooter.vue?vue&type=script&lang=js"

import "./AttributionFooter.vue?vue&type=style&index=0&id=e5c3b896&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5c3b896"]])

export default __exports__